// extracted by mini-css-extract-plugin
export var empty_div = "mediaShareFooter-module--empty_div--cmQEt";
export var share_logos = "mediaShareFooter-module--share_logos--VehcK";